module.exports = __webpack_public_path__ + "static/BcnByBike-d8ac8ab6016f85459c010260f9afe18b.png";